import { defineMessages } from 'react-intl';

export const PromotionComponentLayout2Messages = defineMessages({
  From: {
    id: 'ic.promotion.layout2.from',
    defaultMessage: 'oder ab',
  },
  InstallmentsPrefix: {
    id: 'ic.promotion.layout2.installments.prefix',
    defaultMessage: 'in bequemen',
  },
  Installments: {
    id: 'ic.promotion.layout2.installments',
    defaultMessage: '{installments} Raten',
  },
  CtA: {
    id: 'ic.promotion.layout2.cta',
    defaultMessage: 'Wunschrate berechnen',
  },
});
